/*
 * Author: Harper Yan
 * File Created: Monday, 25-04-14 04:23 pm
 * Last Modified: Monday, 25-05-19 03:29 pm, by Chao.Wang
 */

import { showSnackbar, showStatusDialog } from '@ucard/ds/message';
import type { StatusDialogProps } from '@ucard/ds/message/dialog/templates';

import { ErrorCodeManager, renderTemplate } from '@web/error-code';

export const errorCodeManager = ErrorCodeManager.initialize({
  scope: ['decard'],
  showErrorInfo: (detail, data) => {
    if (typeof window === 'undefined') {
      return;
    }

    if (detail.action === 'modal') {
      const close = showStatusDialog({
        header: detail.header!,
        content: renderTemplate(detail.msg, data),
        // buttons
        ...(detail.btn1 && {
          btn1: {
            label: detail.btn1,
            onClick: () => {
              close();
            },
          },
        }),
        ...(detail.btn2 && {
          btn2: {
            label: detail.btn2,
            onClick: () => {
              close();
            },
          },
        }),
        width: '300px',
      } as StatusDialogProps);
    } else if (detail.action === 'toast') {
      showSnackbar({
        message: renderTemplate(detail.msg, data),
        autoHideDuration: 3000,
      });
    }
  },
});
